module.exports = __webpack_public_path__ + "static/gradient_6-7ad42b7489839526919c18452307e968.png";